<template>
	<AppModal :settings="modalSettings">
		<TheReservationAppModalContent />
	</AppModal>
</template>

<script>
import AppModal from '@/components/App/AppModal';
import TheReservationAppModalContent from './TheReservationAppModalContent';

export default {
	components: {
		AppModal,
		TheReservationAppModalContent,
	},
	data() {
		return {
			modalSettings: {
				name: 'reservationApp',
				title: '예약 전 확인하세요!',
				isUseAlwaysClose: true,
				isOpen: true,
			},
		};
	},
};
</script>
